import React from 'react';
import { Link } from 'react-router-dom';
import { Train, ArrowRight, Compass, Gauge, Rocket } from 'lucide-react';
import SubpageShell from './SubpageShell';
import SEO from '../components/SEO';
import PageHeroImage from '../components/PageHeroImage';
import AcademyProgramme from '../components/academy/AcademyProgramme';
import SimulationExperiences from '../components/academy/SimulationExperiences';
import SimulatorGallery from '../components/academy/SimulatorGallery';
import WorkshopFacts from '../components/academy/WorkshopFacts';
import '../styles/ServiceEnquiry.css';
import '../styles/KnowledgeAZ.css';
import '../styles/N3uropedia.css';
import '../styles/Academy.css';

const LEVELS = [
  { icon: Compass, label: 'Discover (5–7)', body: 'My First Train Journey — stations, platforms and the sensory experience of rail, at a child-friendly pace.' },
  { icon: Gauge, label: 'Explore (8–11)', body: 'How trains work — signalling, carriages and rail operations.' },
  { icon: Rocket, label: 'Advance (12–16)', body: 'Railway systems, journey planning and simulation — real skills, real confidence.' },
];

const AcademyRail = () => (
  <SubpageShell currentPath="/academy/rail">
    <SEO
      title="Rail Academy — N3URO Academy"
      description="Neuro-inclusive learning pathway in rail: trains, railway systems and simulation across three age levels."
      canonical="/academy/rail"
      image="https://n3uro.world/img/share-academy-rail.jpg"
    />
    <main className="subpage-hero">
      <PageHeroImage src="/img/academy-rail.webp" alt="N3URO Academy Rail — children explore a train driver simulator with a rail guide" testId="hero-image-academy-rail" />
      <nav aria-label="Breadcrumb" style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.65)', marginBottom: '0.5rem' }}>
        <Link to="/academy" style={{ color: '#5BE9FF' }}>Academy</Link> &middot; Rail
      </nav>
      <span className="subpage-eyebrow"><Train size={12} /> &nbsp;Rail Academy</span>
      <h1 className="subpage-title">Rail Academy.</h1>
      <p className="subpage-lede">
        A neuro-inclusive learning pathway into rail. From "My First Train Journey" to railway systems
        and simulation, across three carefully-paced levels.
        Each 90-minute workshop is kept small, with <span data-testid="workshop-capacity-rail">no more than 12&ndash;14 children per session and age group</span>, so every child has time and space to settle in.
      </p>

      <figure className="ac-hero-figure" data-testid="academy-rail-hero">
        <img src="/img/academy-rail-hero.webp" alt="A modern train in N3URO WORLD® colours at a platform, with signs reading Accessible Journeys for Every Family" width="1264" height="848" fetchPriority="high" />
      </figure>

      <WorkshopFacts pathway="rail" />

      <section className="service-grid" aria-label="Rail Academy levels">
        {LEVELS.map(({ icon: Icon, label, body }) => (
          <article key={label} className="service-card" style={{ '--accent': '#FFB166' }}>
            <span className="service-card-icon" aria-hidden="true"><Icon size={22} strokeWidth={1.75} /></span>
            <h3>{label}</h3>
            <p>{body}</p>
          </article>
        ))}
      </section>

      <SimulatorGallery pathway="rail" />

      <AcademyProgramme code="RA-01" />
      <SimulationExperiences pathway="rail" />

      <section style={{ marginTop: '2rem' }}>
        <Link to="/academy/register-interest?pathway=rail" className="service-enquiry-submit" data-testid="cta-register-rail" style={{ display: 'inline-flex' }}>
          <span>Register interest in Rail Academy</span>
          <ArrowRight size={16} strokeWidth={2.4} />
        </Link>
        <p className="service-enquiry-note" style={{ marginTop: '0.65rem' }}>
          Registering is free. It is not a booking and no payment is taken.
        </p>
      </section>
    </main>
  </SubpageShell>
);

export default AcademyRail;
